import ModalHeader from '@/components/modal/ModalHeader.tsx';
import React from 'react';
import Modal from '@/components/modal/Modal.tsx';
import ModalFooter from '@/components/modal/ModalFooter.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import {
  CheckboxCustomFieldFormData,
  CheckboxCustomFieldInputData,
  checkboxCustomFieldSchema,
} from '@/features/dashboard/tourCustomFields/schemas/checkboxCustomFieldSchema.ts';
import { tourCustomFieldsRoute } from '@/features/dashboard/tourCustomFields/routes/tourCustomFieldsRoute.ts';
import CheckboxCustomFieldForm from '@/features/dashboard/tourCustomFields/components/CheckboxCustomFieldForm.tsx';
import useUpdateCustomField from '@/features/dashboard/tourCustomFields/hooks/useUpdateCustomField.ts';
import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import { CheckboxCustomFieldDefinitionDto } from '@/features/dashboard/tourCustomFields/types/CheckboxCustomFieldDefinitionDto.ts';

const CheckboxCustomFieldEditModal = ({
  onClose,
  fieldDef,
}: {
  onClose: () => void;
  fieldDef: CheckboxCustomFieldDefinitionDto;
}) => {
  const { tourId } = tourCustomFieldsRoute.useParams();
  const form = useForm<CheckboxCustomFieldInputData>({
    resolver: debugZodResolver(checkboxCustomFieldSchema),
    defaultValues: {
      type: FieldType.CHECKBOX,
      fieldName: fieldDef.name,
      isFieldMandatory: fieldDef.required,
      hint: fieldDef.hint,
      defaultValue: fieldDef.defaultValue ?? false,
    },
  });

  const updateCustomField = useUpdateCustomField(tourId, fieldDef.id);

  const handleSubmit = (data: CheckboxCustomFieldFormData) => {
    updateCustomField.mutate(data, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <Modal onClose={onClose} isDirty={form.formState.isDirty}>
      <ModalHeader title="Edytuj pole checkbox" onClose={onClose} />
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <CheckboxCustomFieldForm />
          <ModalFooter>
            <ActionButton tone="outline" size="sm" onClick={onClose}>
              Zamknij
            </ActionButton>
            <ActionButton tone="accent" size="sm" type="submit">
              Zapisz
            </ActionButton>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default CheckboxCustomFieldEditModal;
